import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
// NOTE: notification needs to be imported as a static function,
// because it can be called from code independent on react.
import { notification } from 'antd';
import { txt } from 'libs/i18n';
import DownloadButton from 'components/DownloadButton';
import { downloadTextFormat } from '../ProjectMenuPanel/exports';
const SaveError = () => (_jsxs("div", { children: [_jsx("h3", { children: txt('saveErrorTitle') }), _jsx("p", { children: txt('checkInternetConnection') }), _jsxs("p", { children: [txt('problemPersists'), _jsx("a", { href: txt('contactLink'), target: "_blank", rel: "noreferrer", children: ` ${txt('contactUs')}.` })] })] }));
export const displayNotification = (saveNotification, trsxExporter, projectName, onImportTheirTrsx) => {
    const dowloadTrsx = () => {
        if (trsxExporter !== undefined) {
            downloadTextFormat(trsxExporter, projectName !== null && projectName !== void 0 ? projectName : 'last_trsx', 'trsx');
        }
        onImportTheirTrsx === null || onImportTheirTrsx === void 0 ? void 0 : onImportTheirTrsx();
    };
    if (saveNotification.type === 'someone-edited') {
        notification.warning({
            message: txt('someoneEditedHead'),
            description: (_jsxs(_Fragment, { children: [_jsx("p", { children: txt('downloadLastTrsxAndReload') }), `${txt('userThatEdited')} ${String(saveNotification.details)}`, _jsx(DownloadButton, { title: txt('dlTrsx'), onDownload: dowloadTrsx, displayTextOnSmallScreen: true })] })),
            placement: 'topRight',
            duration: 0,
            onClose: onImportTheirTrsx !== undefined ? () => onImportTheirTrsx() : undefined,
        });
    }
    if (saveNotification.type === 'save-failed') {
        notification.error({
            message: _jsx(SaveError, {}),
            placement: 'topRight',
            duration: 0,
        });
    }
    if (saveNotification.type === 'trsx-upload-failed') {
        notification.error({
            message: txt('saveFailed'),
            description: (_jsxs(_Fragment, { children: [_jsx("p", { children: txt('downloadLastTrsx') }), _jsx(DownloadButton, { title: txt('dlTrsx'), onDownload: dowloadTrsx, displayTextOnSmallScreen: true })] })),
            placement: 'topRight',
            duration: 0,
        });
    }
    if (saveNotification.type === 'export-failed') {
        notification.error({
            message: txt('saveErrorTitle'),
            description: `${txt('saveFailedRefresh')} ${String(saveNotification.details)}`,
            placement: 'topRight',
            duration: 0,
        });
    }
};
